import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class BrokerAccountsService {
    private readonly http = inject(HttpClient);

    lockTrading(target: TradingLockTarget, reason: string): Observable<LockTradingResult> {
        const request: LockTradingRequest = { reason };
        return this.http.post<LockTradingResult>(tradingLockPath(target), request);
    }

    unlockTrading(target: TradingLockTarget): Observable<UnlockTradingResult> {
        return this.http.delete<UnlockTradingResult>(tradingLockPath(target));
    }
}

// Without a bot id the whole broker account is locked or unlocked; with one, only that bot.
export type TradingLockTarget = {
    brokerAccountId: string;
    botId?: string;
};

export type LockTradingRequest = {
    reason: string;
};

// success is false only when the API refuses the reason; lockedSinceUtc is null when an existing lock's start cannot
// be read, and the lock holds all the same.
export type LockTradingResult = {
    success: boolean;
    error: string | null;
    wasAlreadyLocked: boolean;
    lockedSinceUtc: string | null;
};

export type UnlockTradingResult = {
    wasLocked: boolean;
};

function tradingLockPath(target: TradingLockTarget): string {
    const brokerAccountPath = `/broker-accounts/${target.brokerAccountId}`;
    return target.botId === undefined ? `${brokerAccountPath}/lock` : `${brokerAccountPath}/bots/${target.botId}/lock`;
}
